module.exports = "<h2 id=\"component-description\">Component Description</h2>\n<p>A Nessie MessageBox is a text container useful for displaying text.</p>\n<h2 id=\"example-usage\">Example Usage</h2>\n<pre><code>&lt;MessageBox&gt;Your message goes here&lt;/MessageBox&gt;\n</code></pre>";


//////////////////
// WEBPACK FOOTER
// ./node_modules/html-loader!./node_modules/markdown-loader!./src/MessageBox/README.md
// module id = 361
// module chunks = 0